<script lang="ts">
  import clsx from 'clsx';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import type { HeadingMediumProps } from './types';
  let { class: className, size = 'medium', ...props }: HeadingMediumProps = $props();
</script>

<BaseHeading class={clsx(className)} {size} level={2} {...props} />
